import { Component, ViewChild, OnInit, AfterViewInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { PAGELENGTH } from 'src/app/endpoints';
import { UserDataService } from 'src/app/shared/service/userData/user-data.service';
import { SHARED_IMPORTS } from 'src/app/shared-imports';
import { MatTableDataSource } from '@angular/material/table';
import { HasRoleDirective } from 'src/app/shared/directive/has-role.directive';
import { MatPaginator } from '@angular/material/paginator';
import { DischargeLogsService } from 'src/app/shared/service/dischargeLogs/discharge-logs.service';

@Component({
  selector: 'app-discharge-logs',
  imports: [
    SHARED_IMPORTS,
    DatePipe,
    RouterLink,
    HasRoleDirective,
  ],
  templateUrl: './discharge-logs.component.html',
  styleUrl: './discharge-logs.component.scss'
})
export class DischargeLogsComponent implements OnInit, AfterViewInit {
  startpoint = 0;
  totalLoaded = 0;
  total = 0;
  pageNo = 0;
  pageSize: number = 10;
  
  displayedColumns: string[] = ['position', 'patient', 'ward', 'doctor', 'remarks', 'type', 'createdAt', 'status'];
  dataSource = new MatTableDataSource<any>([]);

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    private dischargeLogsService: DischargeLogsService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    public userDataService: UserDataService
  ) {}

  ngOnInit(): void {
    this.getLogs(null);
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  getDischargeTypeTag(element: any) {
    // Handle string or boolean correctly
    const isTrue = (val: any) => val === true || val === 'true' || val === 1 || val === '1';

    if (isTrue(element?.isDealth)) return { label: 'Death', class: 'badge bg-danger' };
    if (isTrue(element?.isEscape)) return { label: 'Escape', class: 'badge bg-warning text-dark' };
    if (isTrue(element?.isFamilyReunite)) return { label: 'Family Reunite', class: 'badge bg-success' };
    if (isTrue(element?.isFamilyMember)) return { label: 'Family Member', class: 'badge bg-info text-dark' };
    return { label: 'Standard', class: 'badge bg-secondary' };
  }

  getLogs(event: any) {
    this.spinner.show();

    if (!event) {
      this.pageNo = 0;
      this.startpoint = 0;
      this.pageSize = this.pageSize || PAGELENGTH;
      this.dataSource.data = [];
      this.totalLoaded = 0;
    }

    if (event?.pageSize && event.pageSize !== this.pageSize) {
      this.pageSize = event.pageSize;
      this.pageNo = 0;
      this.startpoint = 0;
      this.dataSource.data = [];
      this.totalLoaded = 0;
    }

    if (event?.pageIndex !== undefined) {
      this.pageNo = event.pageIndex;
      this.startpoint = this.pageNo * (this.pageSize || PAGELENGTH);
    }

    const data: any = {
      startpoint: this.startpoint,
      limit: this.pageSize || PAGELENGTH,
    };

    this.dischargeLogsService.getAllDischargeLogs(data).subscribe({
      next: (result: any) => {
        this.spinner.hide();
        if (result.success) {
          console.log('DISCHARGE LOGS DATA:', result.data);
          this.total = result.total ?? 0;
          this.dataSource.data = result.data || [];
          this.totalLoaded = this.dataSource.data.length;

          setTimeout(() => {
            if (this.paginator) {
              this.paginator.pageIndex = this.pageNo;
              this.paginator.length = this.total;
              this.paginator.pageSize = this.pageSize ?? PAGELENGTH;
            }
          }, 0);
        }
      },
      error: (e: any) => {
        this.spinner.hide();
        const errorMsg = e.status === 0 ? 'Server not reachable.' : e.message || 'Unexpected error.';
        this.toastr.error(errorMsg, 'Error');
      },
    });
  }

  markAsRead(log: any) {
    this.spinner.show();
    this.dischargeLogsService.markAsRead(log._id).subscribe({
      next: (result: any) => {
        this.spinner.hide();
        if (result.success) {
          this.toastr.success('Log marked as read successfully');
          log.isRead = true; // Update local state directly
        } else {
          this.toastr.error(result.message || 'Failed to update log');
        }
      },
      error: (e: any) => {
        this.spinner.hide();
        this.toastr.error('Error updating log status');
      }
    });
  }
}
